import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

import { getConsent, saveConsent } from "@/lib/consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const show = () => { setVisible(true); window.dispatchEvent(new Event("cookie-banner-shown")); };
    if (!getConsent()) show();
    window.addEventListener("open-cookie-settings", show);
    return () => window.removeEventListener("open-cookie-settings", show);
  }, []);

  const choose = (value) => {
    const previous = getConsent();
    saveConsent(value);
    setVisible(false);
    // Le rechargement arrête les outils de mesure déjà chargés après un retrait du consentement.
    if (previous === "accepted" && value === "refused") window.location.reload();
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="region"
      aria-label="Gestion des cookies"
      className="fixed bottom-0 left-0 right-0 z-50 border-t-2 border-ink bg-night text-paper animate-in fade-in slide-in-from-bottom-8 duration-300"
    >
      <div className="mx-auto flex max-w-[1440px] flex-col gap-5 px-5 sm:px-8 py-5 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-4">
          <Cookie className="h-5 w-5 shrink-0 text-accent mt-0.5" aria-hidden="true" />
          <p className="text-sm leading-relaxed text-paper/85 max-w-2xl">
            Nous utilisons des cookies pour mesurer l'audience et améliorer votre navigation.
            Vous pouvez accepter ou refuser — votre choix est conservé 13 mois.{" "}
            <Link to="/confidentialite" className="underline underline-offset-4 hover:text-accent" data-testid="cookie-banner-link">
              Politique de confidentialité
            </Link>
          </p>
        </div>
        <div className="flex shrink-0 gap-3">
          <button
            data-testid="cookie-refuse"
            onClick={() => choose("refused")}
            className="border-2 border-paper/60 px-5 py-2.5 font-mono text-[11px] uppercase tracking-[0.15em] transition-colors hover:bg-paper hover:text-night"
          >
            Tout refuser
          </button>
          <button
            data-testid="cookie-accept"
            onClick={() => choose("accepted")}
            className="border-2 border-accent bg-accent px-5 py-2.5 font-mono text-[11px] uppercase tracking-[0.15em] text-paper transition-colors hover:bg-transparent"
          >
            Tout accepter
          </button>
        </div>
      </div>
    </div>
  );
}
